import 'containers/LoaderAndText/spinner.css';
import { nbsp } from '@ipfabric/frontend-shared-assets/utils/characters';
import classNames from 'classnames';
import { useEffect, useState } from 'react';
import type { FC, ReactNode } from 'react';

interface Props {
  bottomText?: string;
  delay?: number;
  error?: ReactNode;
  errorText?: string;
  hasError?: boolean;
  noVerticalMargin?: boolean;
  onShowErrorMessage?: (
    /** @deprecated props.error is just passed there which should already be known by the calling component */
    error: ReactNode,
  ) => void;
  text?: ReactNode;
}

const DISPLAY_TEXT_DELAY_DEFAULT = 5000;

export const LoaderAndText: FC<Props> = (props) => {
  const delay = props.delay ?? DISPLAY_TEXT_DELAY_DEFAULT;
  const [displayText, setDisplayText] = useState(false);

  // biome-ignore lint/correctness/useExhaustiveDependencies(delay):
  // biome-ignore lint/correctness/useExhaustiveDependencies(props.text):
  useEffect(() => {
    if (props.text) {
      const timerId = window.setTimeout(() => {
        setDisplayText(true);
      }, delay);
      return () => {
        window.clearTimeout(timerId);
      };
    }
    return undefined;
  }, []);

  if (props.hasError) {
    return (
      <div
        className={classNames(
          'text-center',
          !props.noVerticalMargin && 'my-20',
          props.onShowErrorMessage && 'cursor-pointer',
        )}
        onClick={
          props.onShowErrorMessage &&
          (() => {
            props.onShowErrorMessage!(props.error);
          })
        }
      >
        <i className='fa fa-exclamation-triangle fa-4x animated headShake text-orange-400' />
        <p>{props.errorText}</p>
      </div>
    );
  }
  return (
    <div className={classNames('spinner', !props.noVerticalMargin && 'my-20')}>
      <h4 className='animated fadeInDown'>
        {displayText && props.text ? props.text : nbsp}
      </h4>
      <div className='bounce1' />
      <div className='bounce2' />
      <div className='bounce3' />
      {props.bottomText && <p>{props.bottomText}</p>}
    </div>
  );
};
